import React from 'react';
import { ContentCard } from '../components';
import { externalLinks } from '../utils/text-data/social-media-links';
import clsx from 'clsx';

const touchColors = ['hover:bg-skyBlue60', 'hover:bg-pink60', 'hover:bg-yellow60'];
export const ContactMeSection = () => {
  return (
    <ContentCard
      id='connectWithMe'
      className={'select-none bg-transparent shadow-none md:p-0 gap-12 justify-center items-center min-h-screen'}>
      <div className='flex gap-4 items-center justify-center'>
        {externalLinks?.map((item, key) => (
          <a
            key={key}
            href={item?.url}
            target='_blank'
            rel='noreferrer'
            className={clsx(
              'p-2 rounded-full outline outline-1 outline-black',
              touchColors[key % touchColors?.length]
            )}>
            <img src={item?.icon} width='24px' height='24px' alt={`${item?.label}'s Icon`} />
          </a>
        ))}
      </div>
      <div className='relative flex flex-col md:flex-row items-center'>
        <h1 className='font-fraunces text-center text-[2.5rem]'>Don't Be Shy, Connect & Say Hello!</h1>
        <span className='max-md:absolute md:relative max-md:left-[70%] max-md:top-[60%] max-md:origin-[50%_50%] pb-2 w-fit text-[2.25rem] animate-[wiggle_1s_ease-in-out_infinite]'>
          👋
        </span>
      </div>
      <a
        className='outline outline-1 outline-black px-6 py-2 rounded-full text-xl hover:bg-orange60'
        href={'mailto:pmeet7895@gmail.com'}>
        Get in touch
      </a>
    </ContentCard>
  );
};
